// generic modal to show message

import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import {
    Close as CloseIcon,
    Check as YesIcon
} from '@mui/icons-material';

import Button from '@/components/Button';

import { html as htmlFormat } from '@/utils/Format';

export default function InformationModal({t, open, setOpen, title, text, html, actionText, action, fullScreen}){

	const { sxDialog/*, sxCloseIcon*/ } = getModalStyle();

    const handleClose = () => {
        setOpen(false);
    }

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth='lg'
        >
        	<DialogTitle className='modal-title'>
                {title}
            </DialogTitle>
            {/*
            <IconButton                    
                onClick={handleClose}
                sx={sxCloseIcon}
            >
                <CloseIcon />
            </IconButton> 
            */}
            <DialogContent className='modal-content text-center'>
                {
                    html ?
                        <div dangerouslySetInnerHTML={{__html: htmlFormat(html)}}></div>
                    :
                        text
                }
            </DialogContent>
            <div className="modal-buttons">
                {
                    action &&
                    <div className='me-1'>
                        {
                            actionText && actionText?.length > 0 ?
                                <Button 
                                    className='app-button'
                                    type='accept' 
                                    onClick={action}
                                    text={actionText}
                                />
                            :                                
                                <YesIcon className='action-button-modal text-red-600' onClick={action}/>
                        }
                    </div>
                }
                <div className=''>
                    <Button     
                        className='app-button'
                        onClick={handleClose}
                        type='back'
                        text={t('actions.close.button')}
                    /> 
                </div>
            </div>
        </Dialog>
  );
}